<template>
  <div class="panel">
    <div class="flex flex-between">
      <div class="panel-title">
        {{ title }}
        <el-popover
          v-if="infoContents.length != 0"
          placement="top-start"
          title="统计方法"
          width="400"
          trigger="hover"
        >
          <div>
            <div
              v-for="(content, index) of infoContents"
              :key="index"
              class="mgb10 font8"
            >
              {{ content }}
            </div>
          </div>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </div>
      <div class="text-right"><slot name="right"></slot></div>
    </div>
    <div class="panel-main">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    infoContents: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.panel {
  padding: 10px 16px;
  background: #ffffff;
  border-top: 2px solid #b29d6b;
  box-shadow: 5px 5px 5px 0px #eeeeee;
}
.panel-title {
  font-size: 14px;
  color: #999999;
  padding-bottom: 10px;
}
</style>